/* eslint-disable */

(function ($, Drupal, drupalSettings) {

  'use strict';

  function loadCityView(destinationTags, experienceTags, context) {
    var args = [];
    args.push(destinationTags);
    if (experienceTags) {
      args.push(experienceTags);
    }

    var lift_view = $('.view-lift-teasers');
    var display = 'cityview';
    if ($('.view-display-id-nine_teaser_display').length) {
      display = 'nine_teaser_display';
    }
    if ($('.view-display-id-nine_teaser_display_no_lift').length ||
      $('.view-display-id-cityview_no_lift').length) {
      // Kill lift replacement.
      lift_view = $('.view-lift-teasers-no-lift');
    }
    if ($('.view-display-id-cityview_no_lift').length) {
      $('.view-display-id-cityview_no_lift .view-header').prependTo('.view-display-id-cityview_no_lift .view-content');
    }
    var i = 0;
    lift_view.each(function () {
      $(this).each(function () {
        lift_view.attr('id', 'view-lift-teaser-' + i);
        lift_view.addClass('js-view-dom-id-' + lift_view.attr('id'));
        ++i;

        var data = {view_dom_id: $(this).attr('id'),
                    view_name: 'lift_teasers',
                    view_display_id: display,
                    view_args: args.join('/')};

        $.ajax({
          url: '/lift_views/ajax',
          type: 'GET',
          data: data,
          success: function (response) {
            var destination_name = '';
            if (typeof drupalSettings.tn_vacation_lift.all_destination_tags[destinationTags] !== 'undefined') {
              destination_name = drupalSettings.tn_vacation_lift.all_destination_tags[destinationTags].name;
            }

            for (var iter in response) {
              if (response[iter]) {
                var response_data = response[iter];
                if (response_data.command === 'insert') {
                  response_data.data = response_data.data.replace('<span class="destination-name"></span>', destination_name);
                  if (response_data.method === 'replaceWith') {
                    $(response_data.selector).replaceWith(response_data.data);
                    // Run behaviors on new view.
                    Drupal.attachBehaviors($(response_data.selector)[0]);
                    $('.view-display-id-cityview .view-header').prependTo('.view-display-id-cityview .view-content');
                  }
                  else if (response_data.method === 'append') {
                    $(response_data.selector).append(response_data.data);
                  }
                }
              }
            }
          },
          complete: function (data) {
            if (display === 'nine_teaser_display') {
              Drupal.behaviors.LiftTeasersSlider.initLiftTeaserSlider();
            }
          },
          error: function (xhr) {
          },
          dataType: 'json'
        });
      });
    });
  }


  // # sourceMappingURL=maps/scripts.js.map
  /*eslint-disable */
  $(document).on('acquiaLiftWebSegments', function(event, segments, currentCapture) {
    processLiftSegments(event, segments, currentCapture);
    Drupal.blazy.init.revalidate();
  });

  function processLiftSegments(event, segments, currentCapture) {
    if (typeof drupalSettings === 'undefined') {
      setTimeout(function() { processLiftSegments(event, segments, currentCapture) }, 10);
      return;
    }

    var parsed_experience = [];
    var parsed_destination = [];

    if (segments != null) {
      var seg = '';
      for (i = 0; i < segments.length; i++) {
        var segment = segments[i];
        var tid = drupalSettings.tn_vacation_lift.all_experience_tags[segment];

        if (tid && typeof tid !== 'undefined') {
          parsed_experience.push(tid.tid);
        }
        else {
          tid = drupalSettings.tn_vacation_lift.all_destination_tags[segment];
          if (tid && typeof tid !== 'undefined') {
            parsed_destination.push(tid.tid);
          }
        }
      }
    }

    var experience_tags = parsed_experience.join(',');
    var destinations = parsed_destination.join(',');
    if (typeof drupalSettings.tn_vacation_lift.destination_tags !== 'undefined') {
      destinations = drupalSettings.tn_vacation_lift.destination_tags.join(',');
    }
    loadCityView(destinations, experience_tags);

    /*
    for (var i in Drupal.behaviors) {
      var func  = Drupal.behaviors[i].attach_lift_segments
      var getType = {};
      if (func && getType.toString.call(func) === '[object Function]') {
        func(segments, parsed_destination, parsed_experience);
      }
    }
    */
  }


  Drupal.behaviors.tnvLift = {
    attach: function () {
      $('.view-display-id-cityview .view-header').prependTo('.view-display-id-cityview .view-content');
    }
  };


})(jQuery, Drupal, drupalSettings);
